<template>
  <div>
    <loader/>
    <router-view/>
  </div>
</template>

<script>
import Loader from "@/components/layout/animations/loader";
import {errorHandler} from "@/Services/errorHandler";
export default {
  name: 'App',
  components: {Loader},
  beforeMount() {
    this.$store.dispatch('getVersion');
  },
  created() {
    this.istInitialized();
    this.interval = setInterval(this.istInitialized,10 * 60 * 1000)
  },
  data(){
    return {
      numberOfEncryptions: 18,
      interval : null,
    }
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
  methods : {
    istInitialized(){
      if (this.$route.name === 'Login') return ;
      this.$store.commit('setLoadingState', true);
      return this.$store.dispatch('IsSmartInitialized').then(res => {
        console.log('res',res);
        // Online VSDC mode: do not write or transform Api-key here
        if (res && res.onlineVsdc) {
          this.$store.commit('setLoadingState', false);
          return;
        }
        // Legacy/local mode: only persist if backend returned a string key
        if (typeof res === 'string' && res) {
          let encoded = res;
          for (let i = 0; i < this.numberOfEncryptions; i++) {
            encoded = window.btoa(encoded);
          }
          localStorage.setItem('Api-key', encoded);
        }
        if (!res) {
          return this.$router.push('/signup');
        }
        this.$store.commit('setLoadingState', false);
      }).catch(err => {
        if (err.status === 403) {
          return this.$router.push({ name : `Login` });
        }
        return  errorHandler.tomcatError(err, false, `Initialization Failed`)
      }).finally(() => this.$store.commit('setLoadingState', false));
    },
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
